import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph, Button } from '@fs/zion-ui'
import { NoticeLoading } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { useGroupData, useImageOrganizeActions } from '../../hooks'
import { workflowStatuses } from '../../helpers'

export default function MarkMetadataCompleteDialog({ overlay, handleSave }) {
  const {
    itemNumber,
    group: { id: groupId },
  } = useGroupData()
  const { updateMetadataWorkflowStatus } = useImageOrganizeActions()
  const [t] = useTranslation()
  const [saving, setSaving] = useState(false)

  const trans = {
    title: t('groupdata.markMetadataComplete.title', 'Mark complete?'),
    body: t(
      'groupdata.markMetadataComplete.body',
      'Would you like to mark the Correct Metadata task complete for Item {itemNumber}? Your metadata changes will be saved no matter which option you select.',
      { itemNumber }
    ),
    doMark: t('groupData.markMetadataComplete.doMark', 'Mark Complete'),
    doNotMark: t('groupData.markMetadataComplete.doNotMark', 'Do Not Mark Complete'),
  }

  const doMarkMetadataComplete = async () => {
    setSaving('marking')
    try {
      await handleSave()
      await updateMetadataWorkflowStatus(groupId, workflowStatuses.COMPLETED)
    } catch (err) {
      console.error(err)
    }
    setSaving(false)
  }

  async function doNotMark() {
    setSaving('notMarking')
    await handleSave()
    setSaving(false)
  }

  return (
    <DialogOverlay {...overlay} title={trans.title}>
      <Paragraph size="sm">{trans.body}</Paragraph>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button onClick={doNotMark} Icon={saving === 'notMarking' && NoticeLoading} disabled={saving}>
            {trans.doNotMark}
          </Button>
          <Button
            onClick={doMarkMetadataComplete}
            emphasis="high"
            Icon={saving === 'marking' && NoticeLoading}
            disabled={saving}
          >
            {trans.doMark}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}

MarkMetadataCompleteDialog.propTypes = {
  overlay: PropTypes.shape({
    isOpen: PropTypes.bool,
    open: PropTypes.func,
    handleClick: PropTypes.func,
    targetRef: PropTypes.instanceOf(Object),
  }),
  handleSave: PropTypes.func,
}
